/**
 * Incident Editor Dialog - Payload Tab (PROJ-007)
 * Technical metadata and structured JSON data
 */

import { Alert, AlertDescription } from '@/components/ui/alert';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Code } from 'lucide-react';
import type { UseFormReturn } from 'react-hook-form';
import type { IncidentFormData } from './types';

interface PayloadTabProps {
  form: UseFormReturn<IncidentFormData>;
}

export function PayloadTab({ form }: PayloadTabProps) {
  return (
    <div className="space-y-6">
      <Alert>
        <Code className="h-4 w-4" />
        <AlertDescription>
          Datos técnicos estructurados en formato JSON
        </AlertDescription>
      </Alert>

      <FormField
        control={form.control}
        name="details"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Metadatos Técnicos (JSON)</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder='{"errorCode": "E500", "server": "prod-api-01", "timestamp": "2025-01-15T10:30:00Z"}'
                rows={12}
                className="resize-none font-mono text-xs"
              />
            </FormControl>
            <FormDescription>
              <strong>Datos estructurados:</strong> Información técnica en formato JSON (IDs de sistemas, códigos de error, logs, etc.)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
